'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "MenuDivider", {
    enumerable: true,
    get: function() {
        return MenuDivider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _useMenuDivider = require("./useMenuDivider");
const _useMenuDividerStylesstyles = require("./useMenuDividerStyles.styles");
const _renderMenuDivider = require("./renderMenuDivider");
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const MenuDivider = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useMenuDivider.useMenuDivider_unstable)(props, ref);
    (0, _useMenuDividerStylesstyles.useMenuDividerStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useMenuDividerStyles_unstable')(state);
    return (0, _renderMenuDivider.renderMenuDivider_unstable)(state);
});
MenuDivider.displayName = 'MenuDivider';
